module.exports = __webpack_public_path__ + "static/img/7bg_10.7793a46.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/7bg_10.png
// module id = 737
// module chunks = 1